export const BASE_URL = 'http://103.61.224.178:8073';
export default BASE_URL;
